import React, { PureComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import DriveContext from "../../driveContext";
import styles from "./listNode.module.css";

import { generateUUID, getFileTypeIcon } from "../../../../utils/utils";

const DOUBLE_TAP_MS = 450;
const SYNTHETIC_CLICK_SUPPRESS_MS = 500;

class ListNode extends PureComponent {
	constructor(props) {
		super(props);
		this.lastTouchTapAt = 0;
		this.lastTouchTapKey = null;
		this.suppressClickUntil = 0;
		this.touchStart = null;
		autoBind(this);
	}

	getTapKey() {
		const { node } = this.props;
		return node.guid || node.id || node.fullPath || node.path || node.name;
	}

	handleClick(event) {
		if (Date.now() < this.suppressClickUntil) {
			return;
		}

		if (event.detail === 2) {
			this.handleDblClick();
		} else {
			this.handleSelect();
		}
	}

	handleTouchStart(event) {
		const touch = event.touches && event.touches[0];
		this.touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
	}

	handleTouchEnd(event) {
		if (this.props.node.type !== "folder") {
			return;
		}

		const touch = event.changedTouches && event.changedTouches[0];
		if (this.touchStart && touch) {
			const deltaX = Math.abs(touch.clientX - this.touchStart.x);
			const deltaY = Math.abs(touch.clientY - this.touchStart.y);
			if (deltaX > 10 || deltaY > 10) {
				this.touchStart = null;
				return;
			}
		}
		this.touchStart = null;

		event.preventDefault();
		event.stopPropagation();
		this.suppressClickUntil = Date.now() + SYNTHETIC_CLICK_SUPPRESS_MS;

		const now = Date.now();
		const tapKey = this.getTapKey();
		const isDoubleTap = this.lastTouchTapKey === tapKey && now - this.lastTouchTapAt <= DOUBLE_TAP_MS;

		this.lastTouchTapAt = isDoubleTap ? 0 : now;
		this.lastTouchTapKey = isDoubleTap ? null : tapKey;

		if (isDoubleTap) {
			this.handleDblClick();
		} else {
			this.handleSelect();
		}
	}

	handleSelect() {
		if (this.props.onSelect) {
			this.props.onSelect(this.props.node);
		}
	}

	handleDblClick() {
		if (this.props.onDblClick) {
			this.props.onDblClick(this.props.node);
		}
	}

	renderHeader(name, active, type, node, meta, accept) {

		let icon = null;
		if (type === "folder") {
			icon = <FontAwesomeIcon icon={"folder"} />;
		} else if (type === "file") {
			icon = <FontAwesomeIcon icon={getFileTypeIcon(node.ext, node)} />;
		} else {
			icon = <FontAwesomeIcon icon="cloud" />;
		}
		let fnsSelect = {};
		let acceptable = (type === "folder" || !accept || (accept && node && node.metaData && node.metaData.type === accept));
		if (acceptable) {
			fnsSelect = {
				onClick: this.handleClick
			};
			if (type === "folder") {
				fnsSelect.onTouchStart = this.handleTouchStart;
				fnsSelect.onTouchEnd = this.handleTouchEnd;
			}
		}

		return (
			<div className={acceptable ? active ? "header selected" : "header" : "header disabled"} title={name}>
				<div className="name" style={{ flex: 1, alignItems: "center", minHeight: "44px", padding: "10px 8px", display: "flex", flexDirection: "row", width: "100%", touchAction: type === "folder" ? "manipulation" : undefined }} {...fnsSelect}>
					<div className={styles.icon}>{icon}</div>
					<div className={styles["name-container"]}>{name}</div>
				</div>
			</div>
		);
	}

	render() {
		const { node, meta, accept } = this.props;
		const { guid, id, name, type } = node;
		const { active } = meta ? meta : node;

		const key = `node-${guid ? guid : id ? id : generateUUID()}`;

		// console.log("Render node", name, toggled, active);
		return <div key={key} className="node" id={`drive-node-${this.context?.driveComponentId}-${node.guid}`}>
			{this.renderHeader(name, active, type, node, meta, accept)}
		</div>;
	}
}

ListNode.contextType = DriveContext;

export default branch((props) => {
	// console.log("Mapping", props.node.guid, props.node);
	if (props.node.guid) {
		return {
			meta: ["drive", "hierarchyMetadata", props.node.guid]
		};
	} else {
		return {};
	}
}, ListNode);
